import React from 'react';
import { Input } from 'antd';

function InputComponent({ ...props }) {
  return <Input.Password {...props} />;
}

export default InputComponent;
